import * as t from 'io-ts';
import {IntegerSchema} from 'favorlogic-utils';

const optionalPart = t.partial({
    name: t.string,
});
const requiredPart = t.interface({
    code: t.string,
    milkRoomIds: t.array(IntegerSchema),
});

export const UpdateSupplyChainSchema = t.exact(t.intersection([optionalPart, requiredPart]));

export interface UpdateSupplyChain extends t.TypeOf<typeof UpdateSupplyChainSchema> {}
